import module from 'nominas/nomina/module.js'
import template from './template.html'

export default class NominasNominaBancosPagosComponent {
  constructor (NominasNomina, NominasNominaEmpleados, NominasNominaSuministro, NominasNominaBancosPagos, $q) {
    this.NominasNomina = NominasNomina
    this.NominasNominaEmpleados = NominasNominaEmpleados
    this.NominasNominaSuministro = NominasNominaSuministro
    this.NominasNominaBancosPagos = NominasNominaBancosPagos
    this.idEmpresa = null
    this.idNomina = null
    this.$q = $q
    this.error = null
    this.nomina = null
    this.data = null
    this.view = 1
  }

  $onInit () {
    this.$q.all({
        nomina: this.NominasNomina.get(this.idEmpresa, this.idNomina),
        nominaEmpleados: this.NominasNominaEmpleados.get(this.idEmpresa, this.idNomina),
        nominaSuministro: this.NominasNominaSuministro.get(this.idEmpresa, this.idNomina),
        nominaPagos: this.NominasNominaBancosPagos.get(this.idEmpresa, this.idNomina),
      })
      .then(($resolve) => {
        try {
          this.nomina = $resolve.nomina
          this.data = $resolve.nominaEmpleados.map((empleado, index) => {
            if (!$resolve.nominaPagos[empleado.ID_Empresa] || !$resolve.nominaPagos[empleado.ID_Empresa][empleado.ID_Empleado])
              throw 'Error! No se encuentra la información del pago del empleado ' + empleado.ID_Empleado + ' - ' + empleado.Empleado

            let suministro = $resolve.nominaSuministro[index],
              pagos = $resolve.nominaPagos[empleado.ID_Empresa][empleado.ID_Empleado]

            return {
              ID_Empresa: empleado.ID_Empresa,
              ID_Empleado: empleado.ID_Empleado,
              ID_Nomina: this.idNomina,
              Empresa: empleado.Empresa,
              Empleado: empleado.Empleado,
              Total_Pagar: parseFloat((suministro.Total - suministro.Deducciones.total()).toFixed(2)),
              Pagos: pagos,
            }
          })
        } catch (e) {
          return this.$q.reject(e)
        }
      })
      .then(() => this.calcular())
      .catch((error) => (this.error = error))
  }

  calcular () {
    let totalCapturado = this.data
      .map((item) => item.Pagos.reduce((prev, next) => prev + next.Importe, 0))
      .reduce((prev, next) => prev + next, 0)

    let totalPagar = this.data
      .reduce((prev, next) => prev + next.Total_Pagar, 0)

    this.totalCapturado = parseFloat(totalCapturado.toFixed(2))
    this.totalPagar = parseFloat(totalPagar.toFixed(2))
    this.totalPorcentaje = this.totalCapturado / this.totalPagar
  }
}

module.component('nominasNominaBancosPagos', {
  controller: NominasNominaBancosPagosComponent,
  template,
  bindings: {
    idEmpresa: '<',
    idNomina: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/bancos/pagos/component.js